package com.tregz.tremenz.ui.display

import androidx.compose.runtime.Composable

@Composable
actual fun isImmersiveLandscape(): Boolean = false
